import { useLanguage } from "@/i18n/LanguageContext";

const KEYS = [
  "marquee.moo",
  "marquee.hold",
  "marquee.moon",
  "marquee.toTheMoon",
  "marquee.noTax",
  "marquee.lpBurned",
  "marquee.solSpeed",
  "marquee.joinHerd",
];

export const Marquee = () => {
  const { t } = useLanguage();
  return (
    <div
      className="overflow-hidden border-y border-purple-500/20 bg-[#0E0E16] py-4"
      data-testid="marquee"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {KEYS.map((k, i) => (
              <span
                key={`${copy}-${i}`}
                className="font-display flex items-center whitespace-nowrap text-lg font-bold tracking-wide text-[#F5F3FF]/90 sm:text-xl"
              >
                <span className="px-6">{t(k)}</span>
                <span className="text-xl text-[#14F195]">🐮</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
